
import { async_command_dispatcher } from "@/api/client"

export class DownloadMassiveCSVCommand {
    constructor() {}

    async run(ids: Array<number>, date_range: {start: any, end: any}, user_id:number) { // date_range: {start: ... , end: ... }
        
        let args = {company_ids: ids, start_date: undefined, end_date: undefined, user_id:undefined}
        if (date_range.start != null) args.start_date = date_range.start
        if (date_range.end != null) args.end_date = date_range.end
        args.user_id = user_id

        let resOutput
        try {
            resOutput = await async_command_dispatcher.dispatch_with_result('download.massive.csv.companies', args, 1000)
        } catch (error) {
            console.error('Error getting file download url', error)
            resOutput = null
        }
        return resOutput
    }
}